// extracted by mini-css-extract-plugin
export var downloadButton = "download-button_caGqDqE5k04xJFpy2SfZ";